import React, {Component} from 'react'
import {connect} from 'react-redux'
import Resources from '../../../data/services/resources'
import ProductsServicesTab from './productsServiceTab'
import ProductsServicesCategoryTab from './productsServiceCategoryTab'
import Layout from "../../../common/components/layout";
import Page from "../../../common/components/layout/layout-components/page";
import PageHeader from "../../../common/components/layout/layout-components/page/page-header";
import PageHeaderInfo from "../../../common/components/layout/layout-components/page/page-header-info";
import NavResponsive from "../../../common/components/nav-responsive";
import MobileTabs from "../../../common/components/tabs-navigation/mobile-tabs";
import InventoryAdjutmentTab from "./inventoryAdjustmentTab";
import InventoryReport from "../reports/inventory-report";
import {checkPerm} from "../../../common/util/util-helpers";
import {READ_PERM} from "../../../util/util-constants";

class ProductsServicesPage extends Component {

    constructor(props) {
        super(props)
        const tabs = [
            {
                name: 'ProductsServices',
                resource: Resources.ProductsServices,
                current: true,
                visible: true
            },
            {
                name: 'ProductsServicesCategory',
                resource: Resources.ProductsServicesCategory,
                current: false,
                visible: true
            },
            {
                name: 'InventoryAdjustment',
                resource: Resources.InventoryAdjustment,
                current: false,
                visible: true
            },
            {
                name: 'inventory_report',
                resource: Resources.ProductServiceReport,
                current: false,
                visible: true
            },
        ].map((it) => {
            it.visible = checkPerm(it.resource, READ_PERM)
            return it
        })

        this.state = {
            tabs: tabs,
            selectedTab: Resources.ProductsServices,
            breakpoint: {}
        }
    }

    handleTabChange = (resource) => {
        if (resource === this.state.selectedTab) {
            return false
        }

        this.setState({
            tabs: this.state.tabs.map((it) => {
                it.current = it.resource === resource
                return it
            }),
            selectedTab: resource
        })
    }
    handleBreakpointChange = (breakpoint) => {
        this.setState({
            breakpoint
        })
    }

    render() {
        const {translate, resource} = this.props

        return (
            <Layout
                onBreakpointChange={this.handleBreakpointChange}
                isAccessible={!(resource.errorStatus === 2)}
                {...this.props}
            >
                <Page>
                    <PageHeader
                        title={translate('text.products_services')}
                        afterTitle={(
                            <PageHeaderInfo
                                dispatch={this.props.dispatch}
                            />
                        )}
                    />

                    <div className="hidden sm:block">
                        <NavResponsive
                            tabs={this.state.tabs}
                            onTabChange={this.handleTabChange}
                            translate={translate}
                        />
                    </div>

                    <div>
                        <MobileTabs
                            tabs={this.state.tabs}
                            onTabChange={this.handleTabChange}
                            translate={translate}
                        />
                    </div>

                    {this.state.selectedTab === Resources.ProductsServices && (
                        <ProductsServicesTab
                            breakpoint={this.state.breakpoint}
                            {...this.props}/>
                    )}

                    {this.state.selectedTab === Resources.ProductsServicesCategory && (
                        <ProductsServicesCategoryTab
                            breakpoint={this.state.breakpoint}
                            {...this.props}/>
                    )}

                    {this.state.selectedTab === Resources.InventoryAdjustment && (
                        <InventoryAdjutmentTab
                            breakpoint={this.state.breakpoint}
                            {...this.props}/>
                    )}

                    {this.state.selectedTab === Resources.ProductServiceReport && (
                        <InventoryReport
                            dispatch={this.props.dispatch}
                            translate={translate}
                            resource={resource}
                            dialogResource={this.props.dialogResource}
                            thirdResource={this.props.thirdResource}
                        />
                    )}
                </Page>
            </Layout>
        )
    }
}

export default connect(state => state)(ProductsServicesPage)
